import React from "react";
import useDate from "../../../../../../hooks/app/useDate";
import TextEllipsis from "../../../../../text/TextEllipsis";
import ElementsFromTo from "./ElementsFromTo";
import IconTooltipButton from "../../../../../button/IconTooltipButton";

const LogCardMin = ({
  id,
  log = {},
  lc = {},
  currentCurriculum = {},
  onRemove,
  onClick,
  showChange = true,
  className,
}) => {
  const { formatDate } = useDate();

  return (
    <div
      className={[
        "border border-muted rounded py-2 px-2 relative",
        className,
      ].join(" ")}
    >
      <div className="absolute top-0 right-0 z-10">
        {onRemove && (
          <IconTooltipButton
            id={`button-remove-${id}`}
            icon={["fal", "times"]}
            onClick={() => onRemove(log._id)}
            title="Remove"
            className="bg-background"
            color="primary"
            style={{
              backgroundColor: "var(--background)",
            }}
          />
        )}
      </div>
      <div onClick={onClick}>
        {Object.keys(lc?.lcElements || {}).map((key) => (
          <TextEllipsis
            key={key}
            className="text-sm text-primary font-bold"
            children={lc?.lcElements[key]}
          />
        ))}
        <p className="text-xs font-bold text-secondary mt-2">
          Changes: {showChange ? "" : log?.from?.length}
        </p>
        {showChange && (
          <ElementsFromTo
            currentCurriculum={currentCurriculum}
            granularSteps={lc.granularSteps}
            from={log.from}
            to={log.to}
          />
        )}
        <div className="text-right text-muted-foreground opacity-75 mt-2">
          <span className="text-xs ">Marked on </span>
          <b className="text-xs ">{formatDate(log.date)}</b>{" "}
          <span className="text-xs ">
            {log.type === "close" ? "closed " : ""} by{" "}
          </span>{" "}
          <b className="text-xs ">{log?.userName || log?.userCode}</b>
        </div>
      </div>
    </div>
  );
};

export default LogCardMin;
